<template>
    <div class="h-full w-full flex flex-col">
        <RolesFrom mode="edit" :selected-item="selectedItem" @close="$emit('close')" @updated="$emit('updated')" />
    </div>
</template>

<script>
import RolesFrom from "./form.vue";
export default {
    name: "jobs-edit",
    emits: ["updated"],
    components: { RolesFrom, },
    props: ["selectedItem"],
}
</script>